import type { ReactElement } from "react";

import { CsvDownloadButton, CsvDownloadError, useCsvDownload } from "../../components/csv-download-button.js";

/** CSV の上限の件数の書き方（3 桁ごとに区切る）。 */
export const csvLimitLabel = (limit: number): string => limit.toLocaleString("ja-JP");

/**
 * 一覧の上の行（件数と「CSV でダウンロード」）。<b>今の結果の条件をそのまま URL に載せて落とす</b>（docs/screens/36・43）。
 *
 * <b>ボタンは fetch で受け取って保存させる</b>（<c>components/csv-download-button.tsx</c>）。画面は移らず、
 * 失敗したら件数の行の下に断りを出す。
 * 検索の窓の外に置くので、Enter の検索とフォーカスの決まり（<c>useSearchForm</c>）には触らない。
 * 書き出す条件と上限はサーバが決める（上限を超えた分は書かない）。
 */
export function CsvDownload({ url, filePrefix, summary, help, warning }: {
    /** CSV の口（今の結果の条件を載せた URL）。 */
    readonly url: string;
    /** 応答に名前が無いときの名前の頭（サーバの規則と同じ。<c>activity</c> など）。 */
    readonly filePrefix: string;
    /** 左に出す件数の文。 */
    readonly summary: string;
    /** 何を書き出すか（上限）。 */
    readonly help: string;
    /** 上限を超えているときの注意。無ければ出さない。 */
    readonly warning?: string | null;
}): ReactElement {
    const download = useCsvDownload({ url, filePrefix });
    return (
        <div className="mb-3" data-csv-download="">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <p className="text-sm text-slate-500">{summary}</p>
                <CsvDownloadButton download={download} className="btn-secondary btn-sm" />
            </div>
            <CsvDownloadError download={download} />
            <p className="mt-1 text-xs text-slate-500">{help}</p>
            {warning === undefined || warning === null
                ? null
                : <div className="alert-warning mt-2" data-csv-limit="">{warning}</div>}
        </div>
    );
}
